import type { Goal, Score } from '@study-decks/shared'

export interface GoalProgress {
  ratio: number
  reached: boolean
  detail: string
}

function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value))
}

function formatNumber(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(2)
}

export function computeGoalProgress(goal: Goal, scores: Score[]): GoalProgress {
  const matchingScores = scores.filter(
    (score) => score.deckId === goal.deckId && score.mode === goal.mode,
  )
  let current = 0

  if (goal.targetMetric === 'accuracy') {
    current = matchingScores.length ? Math.max(...matchingScores.map((score) => score.accuracy)) : 0
  } else if (goal.targetMetric === 'completions') {
    current = matchingScores.length
  } else {
    current = matchingScores.reduce((total, score) => total + score.durationSeconds, 0) / 60
  }

  const ratio = clamp01(current / goal.targetValue)
  return {
    ratio,
    reached: ratio >= 1,
    detail: `${formatNumber(current)} / ${formatNumber(goal.targetValue)}`,
  }
}
